const alpenBtns = document.querySelectorAll('cxo-collapse-trigger');

/* SLIDE UP */
let alpenSlideUp = (target, duration = 500) => {

    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
    }, duration);
}

/* SLIDE DOWN */
let alpenSlideDown = (target, duration = 500) => {

    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

alpenBtns.forEach((btn) => {

    var attName = btn.getAttribute('xo-name');
    var box = document.querySelector('cxo-collapse[xo-name="' + attName + '"]');


    btn.addEventListener('click', function () {

        if (this.classList.contains('cxo-active')) {
            btn.removeAttribute('xo-active', '');
            btn.classList.remove('cxo-active');
            box.removeAttribute('cxo-active', '');
            box.classList.remove('cxo-active');

            // add animation to hide
            alpenSlideUp(box);
        } else {
            btn.setAttribute('xo-active', '');
            btn.classList.add('cxo-active');
            box.setAttribute('cxo-active', '');
            box.classList.add('cxo-active');

            // add animation to show
            alpenSlideDown(box);
        }
    });
});
